import { useQuery } from '@tanstack/react-query';
import { platformApi } from '../api/platform';

/** The national opt-in map, shared by every platform page that draws it (one
 * cached request) plus the count those pages quote in their copy. */
export function usePlatformStateMap() {
  const { data } = useQuery({ queryKey: ['platform-state-map'], queryFn: platformApi.getStateMap });
  return {
    stateMap: data,
    optedInCount: data?.features.filter((f) => f.properties.opted_in).length,
    total: data?.features.length,
  };
}
